<template>
  <div id="app">
    <Navigation :cssClass="navClass" />
    <div class="page-content">
      <router-view />
    </div>
    <PageFooter />
  </div>
</template>

<script>
import PageFooter from './components/PageFooter.vue'
import Navigation from './components/Navigation.vue'
import EventBus from './EventBus'

export default {
  name: 'App',
  components: {
    PageFooter,
    Navigation
  },
  data () {
    return {
      navClass: ''
    }
  },
  watch: {
    $route (to, from){
      EventBus.$emit(EventBus.constants.HIDE_NAVIGATION)
      setTimeout(() => this.anchorHashCheck(), 5)
      EventBus.$emit(EventBus.constants.NAVIGATION_CLASS_CHANGED, '')
    }
  },
  created () {
    EventBus.$on(EventBus.constants.NAVIGATION_CLASS_CHANGED, (newClass) => this.navClass = newClass)
  },
  methods: {
    anchorHashCheck() {
      if (this.$route.hash) {
        let target = document.getElementById(this.$route.hash.slice(1))
        if (target) {
          window.scrollTo(0, target.offsetTop)
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import "./assets/css/style.scss";
</style>
